/**
 * Availability by location
 * Behaviour for snippets/availability-by-location.liquid.
 *
 * Every variant's rows are already in the HTML, server-rendered from the
 * custom.availability_table metafield. This file only decides which block is visible.
 * It never fetches, so there is no network step between page load and a visible table.
 *
 * Variant changes arrive on the theme's own 'on:variant:change' event (documented in
 * custom.js) - the same contract product-inventory.js and variant-label.js rely on.
 */

if (!customElements.get('availability-by-location')) {
  class AvailabilityByLocation extends HTMLElement {
    connectedCallback() {
      const scope = this.closest('.product-info') || this.closest('.product');
      const variantPicker = scope ? scope.querySelector('variant-picker') : null;

      // Single-variant products have no picker, so nothing can ever change.
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }
    }

    /**
     * Reveals the pre-rendered block for the newly selected variant.
     * @param {object} evt - 'on:variant:change' event; the variant is in evt.detail.
     */
    handleVariantChange(evt) {
      const id = evt.detail && evt.detail.variant && evt.detail.variant.id;
      if (!id) return;

      const next = this.querySelector(`.cz-avail__list[data-variant="${id}"]`);
      if (!next) return; // unknown variant - leave what is on screen

      this.querySelectorAll('.cz-avail__list').forEach((list) => {
        list.hidden = list !== next;
      });
    }
  }

  customElements.define('availability-by-location', AvailabilityByLocation);
}
